import { notification } from "antd";
export const openNotificationWithIcon = (type, msg, color) => {
  const className = `${type ? type : "primary"}`;
  // type === "error" ? "error" : type === "success" ? "success" : "primary";

  notification[type]({
    duration: 4.5,
    message: msg,
    className: className,
    // description: msg,
  });
};
